<div class="sds-list-container">
  <div class="sds-header">
    <h2>{{ 'sds.title' | translate }}</h2>
    <div class="action-buttons">

      <!-- 新增 SDS 改為直接上傳檔案 -->
      <button class="add-btn" (click)="showAddModal = true">
        <i class="fas fa-plus"></i> {{ 'sds.upload' | translate }}
      </button>
    </div>
  </div>

  <div class="loading-indicator" *ngIf="loading">
    <div class="spinner"></div>
    <span>{{ 'sds.loading' | translate }}</span>
  </div>

  <div class="sds-table-wrapper" *ngIf="!loading">
    <table class="sds-table">
      <thead>
        <tr>
            <th>{{ 'sds.file' | translate }}</th>
              <th>{{ 'sds.file_content' | translate }}</th>
                <th (click)="sort('completeness')">
            {{ 'sds.completeness' | translate }} <i [class]="getSortIcon('completeness')"></i>
          </th>
          <th (click)="sort('chineseName')">
            {{ 'sds.chinese_name' | translate }} <i [class]="getSortIcon('chineseName')"></i>
          </th>
          <th (click)="sort('englishName')">
            {{ 'sds.english_name' | translate }} <i [class]="getSortIcon('englishName')"></i>
          </th>
          <!-- <th (click)="sort('partNumber')">
            料號 <i [class]="getSortIcon('partNumber')"></i>
          </th> -->

          <th (click)="sort('versionDate')">
            {{ 'sds.version_date' | translate }} <i [class]="getSortIcon('versionDate')"></i>
          </th>
          <th>{{ 'sds.department' | translate }}</th>

          <th (click)="sort('lastUpdated')">
            {{ 'sds.last_updated' | translate }} <i [class]="getSortIcon('lastUpdated')"></i>
          </th>
          <th (click)="sort('componentCount')">
            {{ 'sds.component_count' | translate }} <i [class]="getSortIcon('componentCount')"></i>
          </th>
          <th>{{ 'sds.regulations' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of filteredItems">
           <td>
            <button class="file-btn" (click)="viewSdsFile(item.fileurl)">
              <i class="fas fa-file-pdf"></i>
              {{ 'sds.view' | translate }}
            </button>
          </td>
            <td>
            <ng-container *ngIf="item.sds_details && objectKeys(item.sds_details).length > 0; else showParseBtn">
              <button class="file-btn" (click)="openSdsDetailsDialog(item)">
                <i class="fas fa-eye"></i>
                {{ 'sds.view_details' | translate }}
              </button>
            </ng-container>
            <ng-template #showParseBtn>
              <ng-container *ngIf="parsingStatus[item.id] && parsingStatus[item.id].loading; else parseBtn">
                <div class="completeness-bar-container" style="width: 100px; display: inline-block; vertical-align: middle;">
                  <div class="completeness-bar-container progress-bar-center-text">
                    <div class="completeness-bar parsing-progress-bar"
                         [style.width.%]="parsingStatus[item.id].percent || 0"
                         [ngClass]="getCompletenessClass(parsingStatus[item.id].percent || 0)"
                         style="height: 18px; border-radius: 4px;">
                    </div>
                    <span class="completeness-text parsing-progress-text progress-bar-center-label">
                      {{ parsingStatus[item.id].percent || 0 }}%
                    </span>
                  </div>
                </div>
              </ng-container>
              <ng-template #parseBtn>
                <button class="auto-parse-btn" (click)="openAutoParseDialog(item)">
                  {{ 'sds.auto_parse' | translate }}
                </button>
              </ng-template>
            </ng-template>
          </td>
          <td>
            <div class="completeness-bar-container">
              <div class="completeness-bar"
                   [style.width.%]="item.completeness"
                   [ngClass]="getCompletenessClass(item.completeness)">
              </div>
              <span class="completeness-text">{{ item.completeness }}%</span>

            </div>
          </td>
          <td>{{ item.chineseName }}</td>
          <td>{{ item.englishName }}</td>
          <!-- <td>{{ item.partNumber }}</td> -->

          <td>{{ item.versionDate }}</td>
          <td>
            <div class="tag-container">
              <span class="tag" *ngFor="let dept of item.departments">{{ dept }}</span>
            </div>
          </td>

          <td>{{ item.lastUpdated }}</td>
          <td>
            <span class="component-count-link"
                  *ngIf="item.componentCount > 0"
                  (click)="openComponentDetailsDialog(item)">
              {{ item.componentCount }}
            </span>
            <span *ngIf="item.componentCount === 0">0</span>
          </td>
          <td>
            <ng-container *ngIf="!item.regulation_details || objectKeys(item.regulation_details).length === 0; else showRegulationDetails">
              <button class="auto-parse-btn" (click)="openRegulationDialog(item)">
                {{ 'sds.auto_determine' | translate }}
              </button>
            </ng-container>
            <ng-template #showRegulationDetails>
              <!-- 若有 regulation_details，可自訂顯示內容 -->
              <span
                *ngIf="item.regulation_details?.regulation_result?.length > 0"
                [title]="getRegulationNames(item.regulation_details.regulation_result)"
                class="component-count-link"
                style="cursor:pointer"
                (click)="openRegulationDetailsDialog(item)">
                {{ item.regulation_details.regulation_result.length }}
              </span>
              <span
                *ngIf="item.regulation_details?.regulation_result?.length === 0"
                style="color: #aaa; cursor: not-allowed;">
                0
              </span>
            </ng-template>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="no-data" *ngIf="filteredItems.length === 0">
      <i class="fas fa-search"></i>
      <p>{{ 'sds.no_data' | translate }}</p>
    </div>
  </div>

  <div class="pagination" *ngIf="totalPages > 1 && !loading">
    <button
      class="page-btn"
      [disabled]="currentPage === 1"
      (click)="changePage(currentPage - 1)"
    >
      <i class="fas fa-chevron-left"></i>
    </button>

    <button
      class="page-btn"
      *ngFor="let page of pageNumbers"
      [class.active]="page === currentPage"
      (click)="changePage(page)"
    >
      {{ page }}
    </button>

    <button
      class="page-btn"
      [disabled]="currentPage === totalPages"
      (click)="changePage(currentPage + 1)"
    >
      <i class="fas fa-chevron-right"></i>
    </button>
  </div>

  <!-- 新增 SDS 上傳模態框（簡化為檔案上傳） -->
  <div class="modal-overlay" *ngIf="showAddModal">
    <div class="modal-container sds-upload-modal">
      <div class="modal-header">
        <h3>{{ 'sds.upload_title' | translate }}</h3>
        <button class="close-btn" (click)="closeAddModal()">
          <i class="fas fa-times"></i>
        </button>
      </div>
      <div class="modal-body">
        <!-- 拖拉區域 -->
        <div
          class="file-drop-area"
          (drop)="onFileDrop($event)"
          (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave($event)"
          [class.dragover]="isDragOver"
        >
          <p>{{ 'sds.drop_files' | translate }}</p>
          <input
            type="file"
            multiple
            accept=".pdf"
            (change)="onFileSelect($event)"
            #fileInput
            style="display:none"
          />
          <button class="select-btn" (click)="fileInput.click()">{{ 'sds.select_files' | translate }}</button>
        </div>
        <!-- 檔案列表 -->
        <div class="file-list" *ngIf="uploadFiles.length > 0">
          <div class="file-list-header">
            {{ 'sds.file_count' | translate:{count: uploadFiles.length} }}
          </div>
          <div class="file-item" *ngFor="let f of uploadFiles; let i = index">
            <span class="file-index">{{ i + 1 }}.</span>
            <span>{{ f.name }}</span>
            <span class="file-size">({{ (f.size / 1024).toFixed(1) }} KB)</span>
            <button class="delete-btn" (click)="removeFile(i)">
              <i class="fas fa-trash"></i>
            </button>
          </div>
        </div>
        <div class="error-message" *ngIf="uploadError">{{ uploadError }}</div>
      </div>
      <div class="modal-footer">
        <button class="cancel-btn" (click)="closeAddModal()" [disabled]="uploading">{{ 'sds.close' | translate }}</button>
        <button class="submit-btn" (click)="uploadSdsFiles()" [disabled]="uploadFiles.length === 0 || uploading">
          <span *ngIf="!uploading">{{ 'sds.start_upload' | translate }}</span>
          <span *ngIf="uploading">{{ 'sds.uploading' | translate }}</span>
        </button>
      </div>
    </div>
  </div>

  <!-- SDS自動解析彈窗 -->
  <div class="modal-overlay" *ngIf="showAutoParseDialog">
    <div class="modal-container">
      <button class="close-btn close-btn-topright" (click)="closeAutoParseDialog()">
        <i class="fas fa-times"></i>
      </button>
      <app-sds-parser
        [selecteditem]="selectedSdsItem"
      ></app-sds-parser>
    </div>
  </div>

  <!-- SDS Details Dialog -->
  <div class="modal-overlay" *ngIf="showSdsDetailsDialog">
    <div class="modal-container" style="max-width: 900px; max-height: 90vh; overflow:auto;">
      <div class="modal-header">
        <h3>{{ 'sds.file_details' | translate }}</h3>
        <button class="close-btn" (click)="closeSdsDetailsDialog()">
          <i class="fas fa-times"></i>
        </button>
      </div>
      <div class="modal-body">
        <app-sds-parser
          [selecteditem]="selectedSdsDetailsItem"
          [viewmodel]="selectedSdsDetailsViewModel">
        </app-sds-parser>
      </div>
    </div>
  </div>

  <!-- 成分詳細資訊彈窗 -->
  <div class="modal-overlay" *ngIf="showComponentDetailsDialog">
    <div class="modal-container" style="max-width: 700px; max-height: 90vh; overflow:auto;">
      <div class="modal-header">
        <h3>{{ 'sds.component_details' | translate }}</h3>
        <button class="close-btn" (click)="closeComponentDetailsDialog()">
          <i class="fas fa-times"></i>
        </button>
      </div>
      <div class="modal-body">
        <ng-container *ngIf="selectedComponentItem?.sds_details?.item3">
          <table class="component-details-table"
            *ngIf="selectedComponentItem?.sds_details?.item3?.materials && selectedComponentItem.sds_details.item3.materials.length > 0">
            <thead>
              <tr>
                <th>{{ 'sds.component_name' | translate }}</th>
                <th>{{ 'sds.english_name' | translate }}</th>
                <th>{{ 'sds.cas_no' | translate }}</th>
                <th>{{ 'sds.percentage' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let comp of selectedComponentItem.sds_details.item3.materials">
                <td>{{ comp.ChineseName || comp.MaterialName || comp.ChemicalZhName || comp.name || '-' }}</td>
                <td>{{ comp.EnglishName || comp.ChemicalEnName || comp.enName || '-' }}</td>
                <td>{{ comp.CasNo || comp.CASNo || comp.casNo || '-' }}</td>
                <td>{{ comp.Percentage || comp.Content || comp.content || '-' }}</td>
              </tr>
            </tbody>
          </table>
          <div *ngIf="!selectedComponentItem.sds_details.item3.materials || selectedComponentItem.sds_details.item3.materials.length === 0">
            {{ 'sds.no_component_data' | translate }}
          </div>
        </ng-container>
        <div *ngIf="!selectedComponentItem?.sds_details?.item3">
          {{ 'sds.no_component_data' | translate }}
        </div>
      </div>
    </div>
  </div>

  <!-- 列管法規自動判定彈窗 -->
  <div class="modal-overlay" *ngIf="showRegulationDialog">
    <div class="modal-container" style="max-width: 900px; max-height: 90vh; overflow:auto;">
      <div class="modal-header">
        <h3>{{ 'sds.regulation_check' | translate }}</h3>
        <button class="close-btn" (click)="closeRegulationDialog()">
          <i class="fas fa-times"></i>
        </button>
      </div>
      <div class="modal-body">
        <app-chemical-regulation
          [inputcomponents]="selectedRegulationMaterials"
          (saveRegulations)="onSaveRegulations($event)"
        ></app-chemical-regulation>
      </div>
    </div>
  </div>

  <!-- 列管法規明細彈窗（移到最外層） -->
  <div class="modal-overlay" *ngIf="showRegulationDetailsDialog">
    <div class="modal-container" style="max-width: 500px; max-height: 90vh; overflow:auto;">
      <div class="modal-header">
        <h3>{{ 'sds.regulation_details' | translate }}</h3>
        <button class="close-btn" (click)="closeRegulationDetailsDialog()">
          <i class="fas fa-times"></i>
        </button>
      </div>
      <div class="modal-body">
        <ng-container *ngIf="selectedRegulationDetailsItem?.regulation_details?.regulation_result?.length > 0; else noRegulation">
          <ol style="padding-left: 1.5em;">
            <li *ngFor="let id of selectedRegulationDetailsItem.regulation_details.regulation_result">
              {{ chemicalIdNameMap[id] || id }}
            </li>
          </ol>
        </ng-container>
        <ng-template #noRegulation>
          <div>{{ 'sds.no_regulation_data' | translate }}</div>
        </ng-template>
      </div>
    </div>
  </div>
</div>
